// Mock data for KRD Consultancy website

export const mockServices = {
  healthSafety: [
    { title: 'Fire Risk Assessments', description: 'Comprehensive fire safety evaluations for your premises' },
    { title: 'Crisis Management Training', description: 'Prepare your team for emergency situations' },
    { title: 'Security Threat Assessments', description: 'Identify and mitigate security vulnerabilities' },
    { title: 'Risk Assessments & Method Statements', description: 'Creation and assistance with RAMS documentation' },
    { title: 'Accident Investigation', description: 'Thorough investigation and reporting services' },
    { title: 'COSHH Assessments', description: 'Control of Substances Hazardous to Health evaluations' },
    { title: 'HAVS Assessments', description: 'Hand Arm Vibration Syndrome risk assessments' },
    { title: 'Manual Handling Assessments', description: 'Reduce workplace injury risks' },
    { title: 'Policies and Procedures', description: 'Bespoke documentation for your business' }
  ],
  environmental: [
    { title: 'Impact Assessments', description: 'Evaluate environmental effects of your operations' },
    { title: 'Noise Assessments', description: 'Monitor and manage workplace noise levels' }
  ],
  other: [
    { title: 'Business Advice', description: 'Strategic guidance for business growth' },
    { title: 'Cost Control & Streamlining', description: 'Optimize operations and reduce expenses' },
    { title: 'Process Creation & Review', description: 'Enhance service delivery for client satisfaction' },
    { title: 'Negotiation Services', description: 'Expert assistance in fund recovery' },
    { title: 'Tender Assistance', description: 'Support with tender preparation and submission' },
    { title: 'Business Structure Advice', description: 'Restructuring and cost remodeling expertise' },
    { title: 'Business Risk Modeling', description: 'Risk analysis and caveat creation' }
  ]
};

export const mockAccreditations = [
  { name: 'CHAS', description: 'Contractors Health and Safety Assessment Scheme' },
  { name: 'Safe Contractor', description: 'Health & Safety Accreditation' },
  { name: 'Construction Line', description: 'UK Register of Pre-Qualified Contractors' },
  { name: 'ISO 9001', description: 'Quality Management Systems' },
  { name: 'ISO 14001', description: 'Environmental Management Systems' },
  { name: 'ISO 45001', description: 'Occupational Health & Safety Management' }
];

export const mockHRServices = [
  { title: 'HR Services', description: 'Outsourced HR solutions (complexity-dependent)' },
  { title: 'Office Services', description: 'Email monitoring, invoicing, bookkeeping' }
];

export const mockContactSubmit = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock contact form submitted:', formData);
      resolve({ success: true, message: 'Message sent successfully!' });
    }, 1000);
  });
};
